import addContact from './images/addContact.svg'
import avatar from './images/avatar.svg'
import sendFax from './images/sendFax.svg'
import fax from './images/fax.svg'
import voicemail from './images/voicemail.svg'
import voicemailInbox from './images/voicemailInbox.svg'
import meeting from './images/meeting.svg'
import calls from './images/calls.svg'
import callsService from './images/callsService.svg'
import message from './images/message.svg'
import messagesContent from './images/messagesContent.svg'

/**
 *
 */
export const getSvg = (name: string) => {
    const svg = {
        avatar,
        'add-contact': addContact,
        fax,
        'send-fax': sendFax,
        voicemail,
        'voicemail-inbox': voicemailInbox,
        meeting,
        calls,
        'calls-service': callsService,
        message,
        'messages-content': messagesContent
    }

    return svg[name as keyof typeof svg]
}
